import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { SET_AUTH_STATUS, SET_INSTITUTE_ACCESS_TOKEN, SET_INSTITUTE_DETAILS } from '../../Reducers/types';
import { Link, Redirect, useHistory } from 'react-router-dom'
import ClipLoader from "react-spinners/ClipLoader";
import { theme } from '../..';
import ForgotPassword from '../../Pages/ForgotPassword/ForgotPassword';
import { sendOtp, verifyOtp } from '../../api/login';
import Snackbar from '@material-ui/core/Snackbar';
import { useTimer } from 'react-timer-hook';

const Login = props => {
    const[SnackBarMessage, setSnackBarMessage] = useState("")
    const[isSnackBarShow, setIsSnackBarShow] = useState(false)     
    const [phone, setPhone] = useState("")
    const [otp, setOtp] = useState("")
    const [error, setError] = useState(null);
    const [redirect, setRedirect] = useState(false)
    const [loading, setLoading] = useState(false)
    const [verifyOtploading, setVerifyOtploading] = useState(false)
    const [showPassword, setShowPassword] = useState(false);
    const [mode, setMode] = useState("login");
    const [showOTPField, setShowOTPField] = useState(false)
    const time = new Date();
    time.setSeconds(time.getSeconds() + 20);
    const [allowResend, setAllowResend] = useState(false)
    const {
        seconds,
        minutes,
        hours,
        days,
        isRunning,
        start: startTimer,
        pause,
        resume,
        restart,
    } = useTimer({ expiryTimestamp: time, autoStart: false, onExpire: () => setAllowResend(true) });

    const dispatch = useDispatch()
    const history = useHistory();

    const authStatus = useSelector((state) => state.ins.authStatus)

    const closeSnack=()=>{
        setIsSnackBarShow(false)
    }
    const handleSendOtp = async () => {
        
        if (phone) {
            if (!loading) {
                setLoading(true)
                setAllowResend(false)
                setError('')
                // const response = await sendOtp(phone)
                if (true) {
                    restart(time,false)
                    startTimer()
                    setShowOTPField(true)
                    setSnackBarMessage("OTP sent successfully")
                    setIsSnackBarShow(true)
                } else {
                    setError("Something went wrong. Please try again later.")
                }
                setLoading(false)
            }
        } else {
            setError("Please  provide registered mobile number.")
        }
    }


    const handleVerifyOtp = async () => {
        if (otp) {
            if (!verifyOtploading) {
                setVerifyOtploading(true)
                setError('')
                // const response = await verifyOtp(otp, phone)
                if (true) {
                    // console.log(response.data)
                    // if (!response.data?.details?.id) {
                    //     setError("This mobile number is not registered with us.")
                    // } else {
                        // const data = response.data
                        dispatch({ type: SET_AUTH_STATUS, payload: { authStatus: true } })
                        // dispatch({ type: SET_INSTITUTE_DETAILS, payload: { insDetails: data.details } })
                        // dispatch({ type: SET_INSTITUTE_ACCESS_TOKEN, payload: { accessToken: data.accessToken } })
                        // localStorage.setItem('ins_token', response.data.accessToken);
                        setRedirect(true)
                        history.push("/dashboard");
                    // }
                } else {
                    setError("Invalid OTP")
                }
                setVerifyOtploading(false)
            }
        } else {
            setError("Please  provide otp sent on your mobile number.")
        }
    }

    const handleChangeMobile = async () => {
        setShowOTPField(false)
    }

    useEffect(() => {
        if (authStatus) {
            history.push("/dashboard")
        }
    }, [])

    const renderLoginForm = () => {
        return (
            <div className="card-body p-md-5">
                <div className="text-center">
                    <img src="assets/images/logo-icon.png" style={{ width: '300px' }} alt="" />
                    <h3 className="mt-4 font-weight-bold">Welcome Back</h3>
                </div>

                <div className="justify-content-center align-items-center d-flex">
                    {error ? (
                        <span style={{ color: 'red', fontWeight: 'bold' }}>{error}</span>
                    ) : (null)}

                </div>
                <div className="form-group mt-4">
                    <label>Phone Number</label>
                    <input type="text" disabled={showOTPField} className="form-control" placeholder="Enter phone number" onChange={(e) => setPhone(e.target.value)} />
                </div>
                {showOTPField ? (
                    <>
                        <label>Otp</label>
                        <div className="input-group mb-3">
                            <input type={"text"} className="form-control" placeholder="Enter your Otp" onChange={(e) => setOtp(e.target.value)} />
                        </div>
                    </>
                ) : (null)}

                <div className="row">
                    <div class="col-md-7">

                    </div>
                    {showOTPField ? (
                        <div class="col-md-5 text-end">
                            <a href="javascript:void(0);"
                                onClick={() => {
                                    if (allowResend) {
                                        handleSendOtp()
                                    }
                                }}>
                                {allowResend ? 'Resend Otp' : `Resend Otp in ${seconds}`}
                            </a>
                        </div>
                    ) : (null)}

                </div>


                {showOTPField ? (
                    <div className="btn-group mt-3 w-100">
                        <button type="button"  className="btn btn-primary btn-block" onClick={() => handleChangeMobile()}>
                            {loading ? (
                                <ClipLoader color={theme.primaryColor} loading={loading} />

                            ) : ('Change Mobile Number')}</button>
                    </div>
                ) : (

                    <div className="btn-group mt-3 w-100">
                        <button type="button" className="btn btn-primary btn-block" onClick={() => handleSendOtp()}>
                            {loading ? (
                                <ClipLoader color={theme.primaryColor} loading={loading} />

                            ) : ('Send Otp')}</button>
                    </div>
                )}


                {showOTPField ? (
                    <div className="btn-group mt-3 w-100">
                        <button type="button" className="btn btn-primary btn-block" onClick={() => handleVerifyOtp()}>
                            {verifyOtploading ? (
                                <ClipLoader color={theme.primaryColor} loading={verifyOtploading} />

                            ) : ('Verify Otp')}</button>
                    </div>
                ) : (null)}


                <hr />
                <p>Don't have an account?<Link to="/signup"> SignUp</Link></p>
            </div>
        )
    }
    return (
        <div className="section-authentication-login d-flex align-items-center justify-content-center mt-5">
            <div className="row">
                <div className="col-12 col-lg-10 mx-auto">
                    <div className="card radius-15">
                        <div className="row no-gutters">
                            <div className="col-lg-6">
                                {renderLoginForm()}
                            </div>
                            <div className="col-lg-6">
                                <img src="assets/images/login-images/login-frent-img.jpg" className="card-img login-img h-100" alt="..." />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Snackbar
                open={isSnackBarShow}
                onClose={(e)=>closeSnack(e)}
                TransitionComponent="TransitionUp"
                message={SnackBarMessage}
            />
        </div>

    )
}
export default Login